import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthorizationCertPeriod, IDialogUpdateCertPeriod } from '@core/model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-cert-periods-dialog',
    templateUrl: './cert-periods-dialog.component.html',
    styleUrls: ['./cert-periods-dialog.component.scss'],
    standalone: false
})
export class CertPeriodsDialogComponent implements OnInit {
  public form: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) { }

  ngOnInit() {
    const model: AuthorizationCertPeriod = this.config.data;
    const effectiveFromDate = new Date(model.effectiveFromDate);
    const effectiveToDate = new Date(model.effectiveToDate);
    this.form = new FormGroup({
      effectiveFromDate: new FormControl(effectiveFromDate),
      effectiveToDate: new FormControl(effectiveToDate),
    });
  }

  onCancel() {
    this.ref.close(null);
  }

  onUpdate() {
    const effectiveFromDate = this.form.value.effectiveFromDate;
    const effectiveToDate = this.form.value.effectiveToDate;

    const result: IDialogUpdateCertPeriod = {
      effectiveFromDate: effectiveFromDate.toISOString().split("T")[0],
      effectiveToDate: effectiveToDate.toISOString().split("T")[0]
    };

    this.ref.close(result);
  }
}
